import { render } from "./Clan.vue?vue&type=template&id=6e20a320"
import script from "./Clan.vue?vue&type=script&lang=js"
export * from "./Clan.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/Lineage-2-Vue-JS-3-Frontend/Lineage-2-Vue-JS-3-Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__